import { Label, Textarea as FBTextArea } from "flowbite-react";
import { useEffect, useState } from "react";

const accessNested = (obj, key) =>
  key
    .split(".")
    .reduce(
      (_obj, _key) => (_obj && typeof _obj === "object" ? _obj[_key] : null),
      obj
    );

function TextArea({
  name,
  placeholder,
  label,
  formik,
  readOnly,
  disabled,
  rows = 4,
  required,
  showError = true,
  id = "",
  className,
  value,
  error,
  onChange,
}) {
  const formikValue = formik ? accessNested(formik.values, name || id) : value;
  const formikError = formik ? accessNested(formik.errors, name || id) : error;
  const formikTouched = formik ? accessNested(formik.touched, name || id) : "";
  required = formik ? formik.isFieldRequired(name || id) : required;

  return (
    <div className={className || ""}>
      {label && (
        <Label
          htmlFor={id}
          className={`${
            required && !readOnly
              ? "after:content-['_*'] after:text-red-500"
              : ""
          }`}
          value={label}
        />
      )}
      <div className="mt-2">
        <FBTextArea
          id={id}
          disabled={disabled}
          name={name}
          readOnly={readOnly}
          placeholder={readOnly ? "----" : placeholder}
          rows={rows}
          className={`${
            readOnly ? "border-none p-0 focus:border-none focus:ring-0" : ""
          }  bg-transparent`}
          style={readOnly ? { resize: "none" } : {}}
          value={formikValue}
          onChange={(e) => {
            if (formik) {
              formik.handleChange(e);
              setTimeout(() => formik.setFieldTouched(name || id, true));
            }
            onChange && onChange(e);
          }}
        />
      </div>
      {showError && (formik?.touched ? formikTouched : false) && (
        <p className="first-letter:uppercase mt-2 text-sm text-red-500">
          {formik?.errors ? formikError : ""}
        </p>
      )}
    </div>
  );
}

export default TextArea;
